interface IProps {
  className?: string;
  style?: React.CSSProperties;
  children: any;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export function Card({
  className,
  style,
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: IProps) {
  return (
    <div
      className={`card ${className}`}
      style={style}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
}
